module.exports = "<router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/Admin/Documents/Dev Projects/search-artist/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main